<template>
    <div class="checkbox" :class="display">
        <div class="box" :class="{'selected' : value}">
            <input
                :id="internalId"
                :name="internalName"
                :disabled="disabled"
                type="checkbox"
                @input="update">
        </div>
        <label
            :for="internalId"
            :class="{'selected' : value}">
            {{label}}
        </label>
    </div>
</template>

<script>
    import { THEMES, SIZES } from '@/data/themes'

    export default {
        name: 'OSJSelect',
        props: {
            value    : Boolean,
            disabled : Boolean,
            label    : String,
            theme    : String,
            size     : String,
            name     : String
        },
        data(){
            return{
                uid : "cb-" + Math.floor( Math.random() * 1000000 )
            }
        },
        methods : {
            update( e ){
                this.$emit('input', e.target.checked)
            }
        },
        computed : {
            display () {
                return [
                    THEMES[this.theme] || THEMES.light,
                    SIZES[this.size] || SIZES.small,
                    this.value ? 'selected' : undefined
                ]
            },
            internalName(){
                return this.name || this.uid
            },
            internalId(){
                return this.internalName + "-" + this.uid
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/vars";

    .box{
        border-radius: $radius;
        margin-right: 1rem;
        flex-shrink: 0;
        position: relative;
        overflow: hidden;
    }

    input{
        position: absolute;
        left: -10%;
        right: 10%;
        top: -10%;
        bottom: 10%;
        width: 120%;
        height: 120%;
        margin: 0;
        border: none;
        outline: none;
        border-radius: 0;
        background: transparent;
        box-shadow: none;
        opacity: 0;
    }

    label{
        font-size: 1.4rem;
        line-height: 1.5rem;
    }
    
    .checkbox{
        display: flex;
        margin-bottom: 1rem;
        cursor: pointer;
    }

    .theme{
        &-dark{
            .box{
                background-color: white;
                border: 1px solid $mid-gray;

                &.selected{
                    border: 1px solid $blue;
                    background-color: $blue;
                }
            }

            label{
                color: $gray;

                &.selected{
                    color: $blue;
                }
            }
        }
        &-light{
            .box{
                background-color: #ccc;
                border: 1px solid #ccc;

                &.selected{
                    background-color: $blue;
                }
            }

            label{
                color: $pale-gray;
                
                &.selected{
                    color: $blue;
                }
            }
        }
    }

    .size{
        &-small{
            .box{
                width: 1.6rem;
                height: 1.6rem;
            }
        }
        &-large{
            .box{
                width: 2rem;
                height: 2rem;
            }

            label{
                font-size: 1.8rem;
            }
        }
    }
</style>